<script setup>
import { useShared } from '../state.js';

const { isComputing } = useShared();
</script>

<template>
  <div v-if="isComputing" class="computing-overlay">
    <div class="computing-box">
      <span class="spinner"></span>
      Computing…
    </div>
  </div>
</template>

<style scoped>

.computing-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.15);
  /* The main thread is actually blocked for the bulk of a compute anyway —
     this isn't here to prevent interaction, just to say why nothing else
     is responding right now. */
  pointer-events: none;
}

.computing-box {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-lg);
  background: var(--color-primary);
  color: var(--color-text-light);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  font-weight: var(--font-weight-semibold);
}

.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: computing-spin 0.7s linear infinite;
}

@keyframes computing-spin {
  to { transform: rotate(360deg); }
}

</style>
